import React from "react";
import { IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import zoomControlStyle from "./zoomControlStyle";

const ZoomControl = ({ viewerRef }) => {
    const classes = zoomControlStyle();

    // Zoom in function
    const handleZoomIn = () => {
        if (viewerRef.current && viewerRef.current.scene?.camera) {
            const camera = viewerRef.current.scene.camera;
            const zoomFactor = 3;
            camera.pan([0, 0, -zoomFactor]);
        };
    };

    // Zoom out function
    const handleZoomOut = () => {
        if (viewerRef.current && viewerRef.current.camera) {
            const camera = viewerRef.current.scene.camera;
            const zoomFactor = 3;
            camera.pan([0, 0, zoomFactor]);
        }
    };

    return (
        <div className={classes.zoomControls}>
            <IconButton className={classes.zoomButton} onClick={handleZoomOut}>
                <RemoveIcon />
            </IconButton>
            <IconButton className={classes.zoomButton} onClick={handleZoomIn}>
                <AddIcon />
            </IconButton>

        </div>
    );
};

export default ZoomControl;
